import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container teasers-slider-nav" }
const _hoisted_2 = { class: "position-relative" }
const _hoisted_3 = ["id"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Previous slide", -1)
const _hoisted_5 = ["id"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Next slide", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper = _resolveComponent("swiper")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_swiper, _normalizeProps(_guardReactiveProps(_ctx.swiperOptions)), {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-icon swiper-button swiper-button-prev teasers-slider-nav--prev",
          id: `teasers-slider-nav--prev-${_ctx.uid}`
        }, [
          _createVNode(_component_inline_svg, {
            src: require('@dw_boilerplate/Partials/Icons/Arrow-long.svg')
          }, null, 8, ["src"]),
          _hoisted_4
        ], 8, _hoisted_3),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-icon swiper-button swiper-button-next teasers-slider-nav--next",
          id: `teasers-slider-nav--next-${_ctx.uid}`
        }, [
          _createVNode(_component_inline_svg, {
            src: require('@dw_boilerplate/Partials/Icons/Arrow-long.svg')
          }, null, 8, ["src"]),
          _hoisted_6
        ], 8, _hoisted_5)
      ])
    ])
  ], 64))
}